import api from './api';

export type ContratoEstado = 'Borrador' | 'Vigente' | 'Suspendido' | 'Finalizado' | 'Anulado';
export type ContratoPeriodicidad =
  | 'Semanal'
  | 'Quincenal'
  | 'Mensual'
  | 'Bimestral'
  | 'Trimestral'
  | 'Semestral'
  | 'Anual';

export const CONTRATO_PERIODICIDADES: ContratoPeriodicidad[] = [
  'Semanal',
  'Quincenal',
  'Mensual',
  'Bimestral',
  'Trimestral',
  'Semestral',
  'Anual',
];

export const CONTRATO_VARIABLES_AYUDA = [
  '{cuota}',
  '{cuotas_total}',
  '{mes}',
  '{mes_anio}',
  '{periodo_desde}',
  '{periodo_hasta}',
  '{oc}',
  '{contrato}',
  '{avance}',
  '{avance_acumulado}',
];

export interface ContratoItem {
  id?: number;
  orden: number;
  codigoProducto: string;
  descripcionPlantilla: string;
  cantidad: number;
  modoPrecio: 'Fijo' | 'ListaPrecios';
  precioUnitario: number;
  bonificacion: number;
  tipoFacturacion: 'Periodica' | 'PorAvance';
  montoTotal?: number | null;
}

export interface ContratoPeriodo {
  id: number;
  nroCuota: number;
  fechaDesde: string;
  fechaHasta: string;
  fechaFacturacion: string;
  nroOrdenCompra?: string | null;
  estado: string;
  importeEsperado: number;
  importeFacturadoNeto: number;
  importePendiente: number;
  nroFormularioFactura?: number | null;
}

export interface ContratoCertificacion {
  id: number;
  contratoItemId: number;
  codigoProducto?: string;
  fecha: string;
  porcentajeAvance: number;
  porcentajeAcumulado: number;
  importe: number;
  nroOrdenCompra?: string | null;
  observaciones?: string | null;
  estado: string;
  importeFacturadoNeto: number;
  importePendiente: number;
  nroFormularioFactura?: number | null;
}

export interface ContratoListItem {
  id: number;
  numero: number;
  nroCliente: number;
  nombreCliente?: string;
  codigoMoneda: number;
  monedaDescripcion?: string;
  codigoLista?: string;
  nroSucursalVenta: number;
  fechaInicio: string;
  fechaFin: string;
  periodicidad: string;
  estado: string;
  nroOrdenCompraCliente?: string;
  montoMensualEstimado: number;
  periodosPendientes: number;
  certificacionesPendientes: number;
}

export interface ContratoDetalle {
  id: number;
  numero: number;
  nroCliente: number;
  nombreCliente?: string;
  codigoMoneda: number;
  monedaDescripcion?: string;
  codigoLista?: string | null;
  nroSucursalVenta: number;
  fechaInicio: string;
  fechaFin: string;
  periodicidad: string;
  modoFacturacion: string;
  diaFacturacion?: number | null;
  nroOrdenCompraCliente?: string | null;
  estado: string;
  observaciones?: string | null;
  usuarioAlta?: string;
  fechaAlta: string;
  usuarioMod?: string | null;
  fechaMod?: string | null;
  items: ContratoItem[];
  periodos: ContratoPeriodo[];
  certificaciones: ContratoCertificacion[];
}

export interface ContratoCreateUpdate {
  nroCliente: number;
  codigoMoneda: number;
  codigoLista?: string | null;
  nroSucursalVenta: number;
  fechaInicio: string;
  fechaFin: string;
  periodicidad: string;
  modoFacturacion: string;
  diaFacturacion?: number | null;
  nroOrdenCompraCliente?: string | null;
  observaciones?: string | null;
  activar?: boolean;
  items: ContratoItem[];
}

export interface ContratoKpis {
  contratosVigentes: number;
  montoContratadoVigente: number;
  pendienteFacturarMoneda: number;
  pendienteFacturarPesos: number;
  periodosVencidos: number;
  avancesSinFacturar: number;
  contratosPorVencer30Dias: number;
}

export interface ContratoFacturacionPreviewLinea {
  tipo: 'Periodo' | 'Certificacion' | string;
  contratoId: number;
  contratoPeriodoId?: number | null;
  contratoCertificacionId?: number | null;
  contratoItemId: number;
  codigoProducto: string;
  descripcionPlantilla: string;
  descripcionResuelta: string;
  cantidad: number;
  precioUnitarioMoneda: number;
  bonificacion: number;
  importeMoneda: number;
  cotizacion: number;
  importePesos: number;
  porcentajeIva: number;
  importeIvaMoneda: number;
  importeConIvaMoneda: number;
  importeConIvaPesos: number;
  nroCuota?: number | null;
  fechaDesde?: string | null;
  fechaHasta?: string | null;
  fechaFacturacion: string;
  nroOrdenCompra?: string | null;
  porcentajeAvance?: number | null;
  porcentajeAcumulado?: number | null;
  seleccionada: boolean;
}

export interface ContratoFacturacionPreviewGrupo {
  contratoId: number;
  numero: number;
  nroCliente: number;
  nombreCliente?: string;
  codigoMoneda: number;
  monedaDescripcion?: string;
  nroSucursalVenta: number;
  nroOrdenCompraCliente?: string;
  cotizacionSugerida: number;
  tipoIvaCliente?: string;
  lineas: ContratoFacturacionPreviewLinea[];
  totalMoneda: number;
  totalPesos: number;
  totalIvaMoneda: number;
  totalConIvaMoneda: number;
  totalConIvaPesos: number;
}

export interface ContratoFacturacionPreview {
  fechaCorte: string;
  contratos: ContratoFacturacionPreviewGrupo[];
  totalLineas: number;
  totalPesos: number;
  totalConIvaPesos: number;
}

export interface ContratoFacturacionConfirmar {
  fechaEmision?: string;
  emitirConCae?: boolean;
  contratos: Array<{
    contratoId: number;
    cotizacion: number;
    lineas: Array<{
      tipo: string;
      contratoId: number;
      contratoPeriodoId?: number | null;
      contratoCertificacionId?: number | null;
      contratoItemId: number;
      codigoProducto: string;
      descripcion: string;
      cantidad: number;
      precioUnitarioMoneda: number;
      bonificacion: number;
      cotizacion: number;
      nroOrdenCompra?: string | null;
    }>;
  }>;
}

export interface ContratoFacturacionResultado {
  contratoId: number;
  numero: number;
  ok: boolean;
  mensaje?: string;
  nroFormulario?: number;
  nroComprobante?: number;
  caeNro?: string;
  caeVencimiento?: string;
  caeObs?: string;
}

export interface ContratoFacturacionConfirmacionResult {
  resultados: ContratoFacturacionResultado[];
  okCount: number;
  errorCount: number;
}

export interface ContratoPagedResult {
  items: ContratoListItem[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

export interface ContratoCertificacionCreate {
  contratoItemId: number;
  fecha: string;
  porcentajeAvance: number;
  nroOrdenCompra?: string;
  observaciones?: string;
}

const contratoVentaService = {
  getAll: async (params: {
    searchTerm?: string;
    nroCliente?: number;
    estado?: string;
    pageNumber?: number;
    pageSize?: number;
  }): Promise<ContratoPagedResult> => {
    const response = await api.get<ContratoPagedResult>('/api/Contratos', { params });
    return response.data;
  },

  getById: async (id: number): Promise<ContratoDetalle> => {
    const response = await api.get<ContratoDetalle>(`/api/Contratos/${id}`);
    return response.data;
  },

  create: async (dto: ContratoCreateUpdate): Promise<ContratoDetalle> => {
    const response = await api.post<ContratoDetalle>('/api/Contratos', dto);
    return response.data;
  },

  update: async (id: number, dto: ContratoCreateUpdate): Promise<ContratoDetalle> => {
    const response = await api.put<ContratoDetalle>(`/api/Contratos/${id}`, dto);
    return response.data;
  },

  cambiarEstado: async (id: number, estado: string): Promise<ContratoDetalle> => {
    const response = await api.post<ContratoDetalle>(`/api/Contratos/${id}/estado`, { estado });
    return response.data;
  },

  getKpis: async (): Promise<ContratoKpis> => {
    const response = await api.get<ContratoKpis>('/api/Contratos/kpis');
    return response.data;
  },

  addCertificacion: async (id: number, dto: ContratoCertificacionCreate): Promise<ContratoCertificacion> => {
    const response = await api.post<ContratoCertificacion>(`/api/Contratos/${id}/certificaciones`, dto);
    return response.data;
  },

  deleteCertificacion: async (id: number, certificacionId: number): Promise<void> => {
    await api.delete(`/api/Contratos/${id}/certificaciones/${certificacionId}`);
  },

  updatePeriodo: async (id: number, periodoId: number, nroOrdenCompra?: string): Promise<ContratoPeriodo> => {
    const response = await api.put<ContratoPeriodo>(`/api/Contratos/${id}/periodos/${periodoId}`, {
      nroOrdenCompra,
    });
    return response.data;
  },

  previewFacturacion: async (fecha?: string): Promise<ContratoFacturacionPreview> => {
    const response = await api.get<ContratoFacturacionPreview>('/api/ContratosFacturacion/preview', {
      params: fecha ? { fecha } : undefined,
    });
    return response.data;
  },

  confirmarFacturacion: async (
    dto: ContratoFacturacionConfirmar
  ): Promise<ContratoFacturacionConfirmacionResult> => {
    const response = await api.post<ContratoFacturacionConfirmacionResult>(
      '/api/ContratosFacturacion/confirmar',
      dto
    );
    return response.data;
  },
};

export default contratoVentaService;
